import { useEffect, useState } from "react";
import { HbrDeleteIcon } from "../newComponents/Mycustomsvgicons";
import { deleteWallpaper, initDB } from "../ConfigureIndexDB";


const WallpaperSelector = ({image, title, getImageClicked}) => {
    const [isImageUrlValid, setImageUrlValid] = useState(true);
    const [showDeleteIcon, setShowDeleteIcon] = useState(false);

    useEffect(()=>{
        if (image.startsWith('blob:')) {
            setShowDeleteIcon(true);
            const img = new Image();
            img.src = image;
            img.onload = () => setImageUrlValid(true);
            img.onerror = () => {
                setImageUrlValid(false);
                setShowDeleteIcon(false); // the icon will automatically be displayed under the item not found text
            }
        }else{
            setShowDeleteIcon(false);
        }
    },[image]);

    const handleDeleteWallpaper=async()=>{
        await initDB();
       await deleteWallpaper(title);
    };

    const handleImageClicked =()=>{
        getImageClicked(image, title);
    };

    return (
    <div className="chatwallpaperselector" style={{position:"relative"}}>
        {isImageUrlValid ? 
            (<img src={image} alt="" onClick={()=>handleImageClicked()}/>)
            :
            (
            <div className="wallpapernotfound flex-column2">
                <span style={{color:"white"}}>{title} not found</span>
                <HbrDeleteIcon width={"1.8em"} height={"1.8em"} fillColour={"white"} handleClick={()=>handleDeleteWallpaper()}/>
            </div>
            )
        }

        {showDeleteIcon && 
                <div style={{borderRadius:"50%", 
                    backgroundColor:"#1a1a1a",
                    padding:"2px",
                    position: "absolute",
                    right:"2px",
                    top:"0px"
                      }}>
                    <HbrDeleteIcon width={"1.8em"} height={"1.8em"} fillColour={"white"} handleClick={()=>handleDeleteWallpaper()}/>
                </div>
        }
    </div>
     );
}
export default WallpaperSelector;